/* Custom 404 Not Found page with navigation and back to home button
   Converted from Next.js to Vite/React */

import { motion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import ContactBar from '@/components/ContactBar';

export default function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>404 - Pagina niet gevonden | Buitn Planten</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="min-h-screen bg-white flex flex-col"
      >
        <ContactBar />
        <Header />

        <main className="flex-1 flex items-center justify-center pt-0 pb- px-6">
          <div className="max-w-5xl w-full grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              className="flex justify-center"
            >
              <img
                src="/assets/404-not-found.webp"
                alt="404 Not Found"
                className="w-full max-w-md h-auto object-contain"
              />
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="space-y-6 text-center lg:text-left"
            >
              <motion.h1
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                className="text-3xl md:text-4xl font-bold text-jv-primary"
              >
                Deze pagina zit (nóg) niet in ons assortiment
              </motion.h1>

              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.5 }}
                className="text-lg text-gray-600 leading-relaxed"
              >
                Sorry, de pagina die je zoekt bestaat niet.<br />
                Ga terug naar de homepagina om ons assortiment te bekijken.
              </motion.p>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.6 }}
              >
                <a href="/">
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    className="px-8 py-4 font-bold text-lg text-white rounded-full transition-all duration-200 shadow-lg hover:shadow-xl"
                    style={{ backgroundColor: '#ffaf2e' }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#e69a26';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = '#ffaf2e';
                    }}
                  >
                    Terug naar home
                  </motion.button>
                </a>
              </motion.div>
            </motion.div>
          </div>
        </main>

        <Footer />
      </motion.div>
    </>
  );
}
